import { API_ICARDIO } from '../constants/env.const';

export function isStagingEnv() {
  return (
    window.location.hostname.includes('staging.labeler.icardio.ai') ||
    (API_ICARDIO?.includes('staging') ?? false) ||
    window.location.hostname.includes('localhost')
  );
}
